
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    //export class ProductsFranchiseeDialog extends Serenity.PropertyDialog<any, any> {
    export class OrderEmailDialog extends Serenity.EntityDialog<OrdersRow, any> {
        protected getFormKey() { return OrderEmailForm.formKey; }
        protected getIdProperty() { return OrdersRow.idProperty; }
        protected getLocalTextPrefix() { return OrdersRow.localTextPrefix; }
        protected getService() { return OrdersService.baseUrl; }

        protected form = new OrderEmailForm(this.idPrefix);
        public rowids: string;

        private checkGrid: OrdersGrid;
        constructor(gridToRefresh, FormMode, rowKeys) {
       
            super();

            this.form = new OrderEmailForm(this.idPrefix);
            //debugger;
            this.rowids = rowKeys;
            this.form.RowIds.value = rowKeys;
            
        }
        
        loadEntity(entity: OrdersRow) {
            super.loadEntity(entity);
            //debugger;
            this.form.RowIds.value = this.rowids;
            this.form.RowIds.getGridField().toggle(false);

        }

     

       
        //onSaveSuccess(response) {
        //    super.onSaveSuccess(response);
        //    //debugger;
        //    if (this.form.RowIds.value != "") {
        //        Q.notifySuccess("Added sucessfully");
        //        //this.Questionsgrid.rowSelection.resetCheckedAndRefresh();
        //        //this.Questionsgrid.refresh();
        //    }

        //}

        protected getDialogButtons(): Serenity.DialogButton[] {
            return [
              
                {
                    text: 'Send Email',
                    click: () => {
                        //debugger;
                        //if (!this.validateBeforeSave())
                        //    return;

                        //if (this.form.CourseId.value == null || Q.isEmptyOrNull(this.form.CourseId.value)) {
                        //    Q.notifyError("Please enter a value!");
                        //    return;
                        //}
                        if (this.form.Status.value == null ||
                            Q.isEmptyOrNull(this.form.Status.value)) {
                            Q.notifyError("Please select a Status!");
                            return;
                        }
                        var id = this.form.RowIds.value;
                        
                        OrdersService.SendEmails({
                            ids: this.form.RowIds.value,
                            status: this.form.Status.value


                        }, response => {
                            //debugger;
                            Q.notifyInfo(

                                'Inserted: ' + (response.Inserted || 0));
                            //debugger;
                            Q.notifySuccess("Email sent Successfully");
                            //if (response.ErrorList != null && response.ErrorList.length > 0) {
                            //    //Q.notifyError(response.ErrorList.join(',\r\n '));
                            //    Q.notifyError("No of Invalid data count.!" + response.ErrorList.length + "Please search 'Error' on Search");
                            //    alert("No of Invalid data count.!" + response.ErrorList.length + "Please search 'Error' on Search");
                            //}

                            this.dialogClose();
                           // this.checkGrid.rowSelection.resetCheckedAndRefresh();
                           // this.checkGrid.refresh();
                        });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }

        protected getDialogTitle(): string {
            return "Send Email";
        }


    }
}